import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-icon-create",
  "use": "app-icon-icon-create-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-icon-create\"><g fill-rule=\"nonzero\" fill=\"none\"><rect stroke=\"#4D84FF\" stroke-width=\"2\" x=\"1\" y=\"1\" width=\"14\" height=\"14\" rx=\"2\" /><path fill=\"#4D84FF\" d=\"M9 5H7v2H5v2h2v2h2V9h2V7H9z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol